/**
 * /me — Session 3d PR 1.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyHubDashboardPage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-hub", employeeId],
    queryFn: () => session3dApi.getHub(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.hub.title", "My Hub")}
        subtitle={t("me.hub.subtitle", "What matters to you today.")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.hub.title", "My Hub"),
          window_label: t("me.hub.window", "today"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.hub.ask_khidmat", "What should I focus on today?")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.hub.detail_note",
                "Khidmat-aggregated dashboard: pending requests · upcoming leaves · next payday · loan repayment due · iqama days · birthday/anniversary reminders.",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
